import { useTranslation } from 'react-i18next';
import { persistPreferredLanguage } from '@/services/notifications';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
];

interface LanguageSwitcherProps {
  /** 'row' = label + select, for a settings card. 'compact' = bare select, e.g. for the login page. */
  variant?: 'row' | 'compact';
  label?: string;
  'aria-label'?: string;
}

export function LanguageSwitcher({ variant = 'row', label, 'aria-label': ariaLabel }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();

  const select = (
    <select
      value={i18n.resolvedLanguage}
      aria-label={variant === 'compact' ? ariaLabel : undefined}
      onChange={(e) => {
        i18n.changeLanguage(e.target.value);
        persistPreferredLanguage(e.target.value);
      }}
      style={{ padding: '8px', borderRadius: '6px', border: '1px solid var(--border)' }}
    >
      {LANGUAGES.map(({ code, label: langLabel }) => (
        <option key={code} value={code}>
          {langLabel}
        </option>
      ))}
    </select>
  );

  if (variant === 'compact') return select;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <label style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>{label}</label>
      {select}
    </div>
  );
}
